// Lightweight helper to read user's lng/lat from local cache (if available).
// We keep this tolerant because different backends / versions may use different field names.

const toFiniteNumber = (v) => {
  if (v === undefined || v === null || v === '') return null
  const n = Number(v)
  return Number.isFinite(n) ? n : null
}

const pickFirstNumber = (obj, keys) => {
  if (!obj) return null
  for (const k of keys) {
    const n = toFiniteNumber(obj[k])
    if (n !== null) return n
  }
  return null
}

const safeJsonParse = (s) => {
  try {
    return JSON.parse(s)
  } catch (e) {
    return null
  }
}

export function getUserLngLat() {
  // SSR / non-browser guard
  if (typeof window === 'undefined' || !window.localStorage) return null

  // Preferred cache (set by utils/location.js)
  const directGeo = safeJsonParse(localStorage.getItem('userGeo') || '')
  if (directGeo) {
    const lng = toFiniteNumber(directGeo.lng)
    const lat = toFiniteNumber(directGeo.lat)
    if (lng !== null && lat !== null) return { lng, lat }
  }

  // Common cache keys used in this project
  const userDetail = safeJsonParse(localStorage.getItem('userDetail') || '')
  const userInfo = safeJsonParse(localStorage.getItem('userInfo') || '')

  // Try a few likely locations (userInfo first, then userDetail.userInfo, then root)
  const candidates = [
    userInfo,
    userDetail && userDetail.userInfo,
    userDetail
  ]

  const lngKeys = ['lng', 'longitude', 'lon', 'long', 'user_lng', 'address_lng']
  const latKeys = ['lat', 'latitude', 'user_lat', 'address_lat']

  for (const obj of candidates) {
    const lng = pickFirstNumber(obj, lngKeys)
    const lat = pickFirstNumber(obj, latKeys)
    if (lng !== null && lat !== null) return { lng, lat }
  }

  // Fallback: direct scalar keys in localStorage (if some page stored them)
  const lng = toFiniteNumber(localStorage.getItem('lng') || localStorage.getItem('longitude'))
  const lat = toFiniteNumber(localStorage.getItem('lat') || localStorage.getItem('latitude'))
  if (lng !== null && lat !== null) return { lng, lat }

  return null
}
